import DashboardLayout from "../../components/DashboardLayout";
import AICatalogComp from "../../components/AICatalog/index";
import { useTranslation } from "react-i18next";

const AICatalogPage = ({}) => {
  const { t } = useTranslation();

  return (
    <DashboardLayout title={t("aiCatalog.title")}>
      <AICatalogComp />
    </DashboardLayout>
  );
};

export default AICatalogPage;
